import { z } from "zod";
import {
  BANK_ACCOUNT_DETAILS,
  EXPECTED_INVOICE_CLEARANCE_DATE,
  EXPECTED_INVOICE_GENERATION_DATE,
  EXPECTED_INVOICE_SUBMISSION_DATE,
  INVOICE_CODE,
  INVOICE_FILE,
  INVOICE_GENERATION_DATE,
  INVOICE_OWNER,
  INVOICE_OWNER_ROLE,
  INVOICE_REMARKS,
  INVOICE_SUBMISSION_DATE,
} from "./consts.ts";

export const schema = z.object({
  // Invoice Lifecycle
  [EXPECTED_INVOICE_GENERATION_DATE]: z.string().optional(),
  [EXPECTED_INVOICE_SUBMISSION_DATE]: z.string().optional(),
  [EXPECTED_INVOICE_CLEARANCE_DATE]: z.string().optional(),
  [INVOICE_GENERATION_DATE]: z.string().optional(),
  [INVOICE_CODE]: z.string().min(1, "Invoice code is required"),
  [INVOICE_FILE]: z.any().optional(),
  [INVOICE_OWNER_ROLE]: z.string().optional(),
  [INVOICE_OWNER]: z.string().min(1, "Invoice owner is required"),
  [BANK_ACCOUNT_DETAILS]: z.string().optional(),
  [INVOICE_SUBMISSION_DATE]: z.string().optional(),
  [INVOICE_REMARKS]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
